import { PageHeader } from "antd";
import cn from "classnames";
import s from "./Breadcrumb.module.css";
import React from "react";

const HomeBreadCrumb = ({
  title,
  subTitle,
  extra,
  childComponent,
}: any): any => {
  return (
    <div className={s.root} style={{ background: "./../../bg-breadcrumb.svg" }}>
     
    </div>
  );
};

export default HomeBreadCrumb;
